import React from "react";
import "../styles/Beneficiaries.scss";

const TransactionDetailsSkeleton: React.FC = () => {
  return (
    <div className="gx-transfer-container">

      {/* Header Skeleton */}
      <div className="gx-transfer-heading">
        <div className="skeleton skeleton-heading">
          <div className="skeleton-amount-group">
            <div className="skeleton skeleton-currency"></div>
            <div className="skeleton skeleton-amount"></div>
          </div>
        </div>
        <div className="gx-rtp_date-skeleton">
          <div className="skeleton skeleton-date"></div>
        </div>
      </div>

      {/* Transfer From Section Skeleton */}
      <div className="gx-card mt-1">
        <div className="gx-card-header">
          <div className="skeleton skeleton-section-title"></div>
          <div className="skeleton skeleton-icon"></div>
        </div>
        <div className="gx-card-body">
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <div className="gx-row" key={`from-${item}`}>
              <div className="skeleton skeleton-label"></div>
              <div className="skeleton skeleton-value"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Transfer To Section Skeleton */}
      <div className="gx-card mt-4">
        <div className="gx-card-header">
          <div className="skeleton skeleton-section-title"></div>
          <div className="skeleton skeleton-icon"></div>
        </div>
        <div className="gx-card-body">
          {[1, 2, 3, 4, 5, 6, 7].map((item) => (
            <div className="gx-row" key={`to-${item}`}>
              <div className="skeleton skeleton-label"></div>
              <div className="skeleton skeleton-value"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Transaction Details Section Skeleton */}
      <div className="gx-card mt-4">
        <div className="gx-card-header">
          <div className="skeleton skeleton-section-title"></div>
          <div className="skeleton skeleton-icon"></div>
        </div>
        <div className="gx-card-body">
          {[1, 2, 3, 4, 5, 6, 7].map((item) => (
            <div className="gx-row" key={`details-${item}`}>
              <div className="skeleton skeleton-label"></div>
              <div className="skeleton skeleton-value"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Payment Timeline Section Skeleton */}
      <div className="gx-card mt-4 payment-progress-td">
        <div className="gx-card-header">
          <div className="skeleton skeleton-section-title"></div>
          <div className="skeleton skeleton-icon"></div>
        </div>
        
        <div className="payment-progress__timeline">

          {/* Step 1 - Payment Initiated */}
          <div className="payment-progress__step flex">
            <div className="gx-vertical-dashedline">
              <div className="skeleton skeleton-step-icon"></div>
              <span className="gx-dashed-line"></span>
            </div>
            <div className="gx-step-connect">
              <div className="gx-step-pointer">
                <div className="skeleton skeleton-step-title"></div>
                <div className="skeleton skeleton-step-date"></div>
              </div>
            </div>
          </div>

          {/* Step 2 - Current Status */}
          <div className="payment-progress__step flex">
            <div className="gx-vertical-dashedline">
              <div className="skeleton skeleton-step-icon"></div>
            </div>
            <div className="gx-step-connect">
              <div className="gx-step-pointer">
                <div className="skeleton skeleton-step-title"></div>
                <div className="skeleton skeleton-step-date"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailsSkeleton;
